<template>
    <div class="container-fluid">
        <div class="page-title" >
            <h4 v-if="!mobile">Groupe d'utilisateurs</h4>
        </div>
        <b-overlay :show="UserGroupisShown" rounded="sm" opacity="0.50 " variant="white striped">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-block">
                        <div class="table-overflow">
                            <b-form-input
                                v-model="filter"
                                type="search"
                                placeholder="Saisissez votre recherche"
                            ></b-form-input>

                            <b-table    :fields="fields" 
                                            :items="items" :filter="filter" 
                                            @filtered="onFiltered"
                                        class='BTable' sticky-header striped no-border-collapse>
                                <template #cell(name)="data">
                                    <span>
                                        {{data.item.name}}
                                    </span>
                                </template>

                                <template #cell(comment)="data">
                                    <span>
                                        {{data.item.comment}}
                                    </span>
                                </template>

                                <template #cell(responsable)="data">
                                    <span>
                                        {{data.item.responsable}}
                                    </span>
                                </template>

                                <template #cell(user_list)="data">
                                    <div class="row text-center align-middle" v-if="data.item.users[0]">
                                        <b-list-group class="col text-center align-middle no_padding">
                                            <b-list-group-item  v-for="user in data.item.users" v-bind:key="user.pivot.id" class="p-0 border-0 bg-transparent">
                                                {{user.title}} {{user.lastname}} {{user.firstname}}
                                            </b-list-group-item>
                                        </b-list-group>
                                        <!--<div class="col-2 no_padding vertical-center">
                                            <button class="btn btn-icon btn-icon btn-default btn-rounded lightBlueColor" @click="usergroup_modal_open(data.item)">
                                                    <i class="ti-user"></i>
                                            </button>
                                        </div>-->
                                    </div>
                                    <!--<div v-else>
                                        <butt²8on class="btn btn-icon btn-icon btn-default btn-rounded lightBlueColor" @click="usergroup_modal_open(data.item)">
                                                <i class="ti-user"></i>
                                        </button>
                                    </div>-->
                                </template>

                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        </b-overlay>
<!-- ######################################################################################### -->
       
        <b-modal ref="usergroup_popup" hide-footer centered size="xl">
            <v-usergroups :group="selected_user_group">

            </v-usergroups>
        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import userGroupEditList from "../../components/userGroupsEditList.vue";

    export default {
        name: "Index",
        components:{
            'v-usergroups': userGroupEditList,
        },
        data () {
            return {
                selected_user_group: {
                    name: "",
                    code: ""
                },
                window: {
                    width: 0,
                    height: 0
                },
                mobile: false,
                tdClass : "text-center align-middle",
                thClass : "text-center",
                
                rows: 1,
                filter: null,
            }
        },
        computed: {
            ...mapGetters({ 
                structure : 'structure/structure',
                user_groups: 'user_groups/user_groups',
            }),

            fields(){       //TODO adapt fields
                var fields=[];
                if(this.mobile){
                fields=[
                    {key :'name', label : 'Nom du groupe', sortable: true, thClass: this.thClass, tdClass:  this.tdClass},
                    {key :'responsable', label : 'Responsable', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                    {key :'user_list', label : 'Utilisateurs', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                    {key :'comment', label : 'Commentaire', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                ];
                }
                else {
                    fields=[
                    {key :'name', label : 'Nom du groupe', sortable: true, thClass: this.thClass, tdClass:  this.tdClass},
                    {key :'responsable', label : 'Responsable', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                    {key :'user_list', label : 'Utilisateurs', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                    {key :'comment', label : 'Commentaire', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                ];
                }
                return fields;
            },
            items(){        //TODO adapt items
                var items=[];
                        
                var responsable="" ;
                for (var group of this.user_groups){
                     

                    //Mise en forme du nom du responsable en interne pour que le tri fonctionne
                    if(group.responsible.title == null){
                        group.responsible.title = "";
                    }
                    
                    if(group.responsible.firstname == null){
                        group.responsible.firstname = "";
                    }
                    
                    if(group.responsible.lastname == null){
                        group.responsible.lastname = "";
                    }
                    if((group.responsible != null) && (group.responsible_id != 1)){
                        responsable = group.responsible.title+" "+group.responsible.firstname+" "+group.responsible.lastname;
                    }
                    else{
                        responsable = " Non défini ";
                    }

                    items.push(
                    {
                        users : group.users,
                        name : group.name,
                        responsable : responsable,
                        comment : group.comment
                    });
                    //RAZ des variables avant le prochain push
                    responsable="" ;
                }
                return items;
            },
            UserGroupisShown (){
                   return this.user_groups.length==0? true : false ;
            },            
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        mounted() {
            this.$store.dispatch('structure/getStructure');
            this.$store.dispatch('user_groups/getGroups');
            this.rows = this.user_groups.length;
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },

        methods: {
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
                this.mobile=(this.window.width<1080)? true : false ;
            },

            onFiltered(filteredItems) {
                this.rows = filteredItems.length
            },

            usergroup_modal_open(group){
                this.selected_user_group = group;
                this.$refs.usergroup_popup.show();
            },
            usergroup_modal_close(){
                //this.selected_system=null;
                this.$refs.usergroups_popup.hide();
            },
        }

    }
</script>

<style>

.asc:after{
    content: "\25B2"
}

.desc:after{
    content: "\25BC"
}
.BTable{
    max-height: 700px;
}
.lightBlueColor:enabled{
  background-color: rgba(200, 217, 255, 0.68);
}

.fake_button{

    margin-top:8px;
    pointer-events: none;
}

.no_padding{
    padding-right: 0px;
    padding-left: 0px;
}

.vertical-center {
  margin: 0;
  position: relative;
 /* top: 10%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);*/
}

</style>